
export function backendUrl() {
    // stage
    return "https://q1.interb2b.com:8753/api/v1"
}

export function ownStyleCSSUrl() {
    return backendUrl() + "/style.css";
}